import {
    CREATE_PRESCRIPTION,
    CREATE_PRESCRIPTION_SUCCESS,
    CREATE_PRESCRIPTION_FAIL,
    GET_PRESCRIPTIONS,
    GET_PRESCRIPTIONS_SUCCESS,
    GET_PRESCRIPTIONS_FAIL,
    UPDATE_PRESCRIPTION,
    UPDATE_PRESCRIPTION_SUCCESS,
    UPDATE_PRESCRIPTION_FAIL,
    DELETE_PRESCRIPTION,
    DELETE_PRESCRIPTION_SUCCESS,
    DELETE_PRESCRIPTION_FAIL,
  } from '../actions/types';
  
  const initialState = {
    prescriptions: [],
    loading: false,
    error: null,
  };
  
  const prescriptionReducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_PRESCRIPTION:
      case GET_PRESCRIPTIONS:
      case UPDATE_PRESCRIPTION:
      case DELETE_PRESCRIPTION:
        return { ...state, loading: true, error: null };
  
      case CREATE_PRESCRIPTION_SUCCESS:
        return {
          ...state,
          loading: false,
          prescriptions: [...state.prescriptions, action.payload],
        };
  
      case GET_PRESCRIPTIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          prescriptions: action.payload,
        };
  
      case UPDATE_PRESCRIPTION_SUCCESS:
        return {
          ...state,
          loading: false,
          prescriptions: state.prescriptions.map((pres) =>
            pres._id === action.payload._id ? action.payload : pres
          ),
        };
  
      case DELETE_PRESCRIPTION_SUCCESS:
        return {
          ...state,
          loading: false,
          prescriptions: state.prescriptions.filter(
            (pres) => pres._id !== action.payload
          ),
        };
  
      case CREATE_PRESCRIPTION_FAIL:
      case GET_PRESCRIPTIONS_FAIL:
      case UPDATE_PRESCRIPTION_FAIL:
      case DELETE_PRESCRIPTION_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default prescriptionReducer;
  